import { render } from "./ThreeDScenePropsCmp.vue?vue&type=template&id=189b3d1e"
import script from "./ThreeDScenePropsCmp.vue?vue&type=script&lang=js"
export * from "./ThreeDScenePropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__